import { render, staticRenderFns } from "./InventoryMobile.vue?vue&type=template&id=b3f5455e&"
import script from "./InventoryMobile.vue?vue&type=script&lang=js&"
export * from "./InventoryMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QCard})
